import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from '@services/api.service';
import { TreoAnimations } from '@treo/animations';

@Component({
  selector: 'ew-edit-bank-account',
  templateUrl: './edit-bank-account.component.html',
  styleUrls: ['./edit-bank-account.component.scss'],
  animations: TreoAnimations,
})
export class EditBankAccountComponent {
  @Output() updated = new EventEmitter<any>();

  get validations(): boolean[] {
    return [this.form.controls.alias.valid, this.form.valid];
  }

  success: boolean = false;
  loading: boolean = false;
  errors: any = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { bankAccount: any },
    private fb: FormBuilder,
    private api: ApiService,
  ) {
    this.form.patchValue({
      alias: data.bankAccount.alias,
    });
  }

  form = this.fb.group({
    alias: new FormControl('', [
      Validators.required,
      Validators.minLength(2),
      Validators.maxLength(30),
    ]),
  });

  get controls() {
    return this.form.controls;
  }

  updateBankAccount() {
    this.loading = true;
    this.api
      .patch(`v1/bank-accounts/${this.data.bankAccount.bank_account_id}`, {
        alias: this.form.value.alias,
      })
      .subscribe(
        () => {
          this.success = true;
          this.loading = false;
          this.updated.emit();
        },
        (error) => {
          this.loading = false;
          this.errors = error.error.errors;
        },
      );
  }
}
